module.exports = __webpack_public_path__ + "static/media/ola_k.985b2ba6.jpg";